import i18next from 'i18next';

import { DISPATCH_METHODS } from '~constants/address';
import { DATA_TEST_ID } from '~constants/tests';

export const TABS_DATA = [
  {
    id: 0,
    value: DISPATCH_METHODS.DELIVERY,
    title: i18next.t('DeliveryOrPickUp:delivery'),
    buttonProps: {
      'data-testid': DATA_TEST_ID.tabDelivery
    }
  },
  {
    id: 1,
    value: DISPATCH_METHODS.PICKUP,
    title: i18next.t('DeliveryOrPickUp:near'),
    buttonProps: {
      'data-testid': DATA_TEST_ID.tabPickup
    }
  }
];
